import { useState } from 'react';
import PublicationAnalysisMethodNote from './PublicationAnalysisMethodNote';
import './CompareWorkshops.css';
import './PublicationAnalysisFigure.css';

const PublicationAnalysisFigure = ({ title, src, alt, text, label, badgeText, comparisonTitle, comparisonFigures }) => {
  const [isModalActive, setIsModalActive] = useState(false);
  const [isRowLayout, setIsRowLayout] = useState(true);
  const [isMissing, setIsMissing] = useState(false);
  const figuresToCompare = Array.isArray(comparisonFigures) ? comparisonFigures : [];
  const hasComparisonModal = figuresToCompare.length > 1;
  const switchId = `layoutSwitch-${`${comparisonTitle || label || title}-${title}`.replace(/[^a-zA-Z0-9_-]/g, '-')}`;

  if (isMissing) {
    return (
      <div className="publication-analysis-card publication-analysis-card-missing">
        <div className="content">
          <h2>{title}</h2>
          <p className="has-text-grey">Analysis diagram is not available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="publication-analysis-card">
      <div className="columns">
        <div className="column">
          <div className="content">
            <h2>
              {title}
              {badgeText && <span className="tag is-light ml-3">{badgeText}</span>}
            </h2>
          </div>
        </div>
        {label && (
          <div className="column is-narrow">
            <span className="tag is-light">{label}</span>
          </div>
        )}
      </div>
      <button
        type="button"
        className="publication-analysis-image-button"
        onClick={() => setIsModalActive(true)}
      >
        <img src={src} alt={alt} onError={() => setIsMissing(true)} />
      </button>
      {text && (
        <div className="content mt-3">
          <p>{text}</p>
        </div>
      )}
      <div className={`modal ${isModalActive ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={() => setIsModalActive(false)}></div>
        <button className="modal-close is-large modal-close-margin" aria-label="close" onClick={() => setIsModalActive(false)}></button>
        {hasComparisonModal && (
          <div className="modal-content comparison-modal-content">
            <div className="block p-6">
              <div className="level mb-5 publication-analysis-comparison-toolbar">
                <div className="level-left">
                  <h3 className="title is-4 has-text-white">{comparisonTitle || `${label || title} - comparison`}</h3>
                </div>
                <div className="level-right">
                  <div className="field" style={{ position: 'relative' }}>
                    <input
                      id={switchId}
                      type="checkbox"
                      name="layoutSwitch"
                      className="switch"
                      checked={!isRowLayout}
                      onChange={() => setIsRowLayout(!isRowLayout)}
                    />
                    <label htmlFor={switchId} className="has-text-white is-size-7">
                      Column View
                    </label>
                  </div>
                </div>
              </div>
              <div className={`${isRowLayout ? 'columns' : 'columns is-multiline'} publication-analysis-comparison-grid`}>
                {figuresToCompare.map(figure => (
                  <div key={figure.landUse} className={isRowLayout ? 'column' : 'column is-full mt-5'}>
                    <figure className="image comparison-modal-chart">
                      <img src={figure.src} alt={figure.alt} />
                    </figure>
                    <div className="has-text-centered mt-3">
                      <h4 className="subtitle is-6 has-text-white">{figure.landUse}</h4>
                    </div>
                  </div>
                ))}
              </div>
              <PublicationAnalysisMethodNote compact inverted />
            </div>
          </div>
        )}
        {!hasComparisonModal && (
          <div className="modal-content publication-analysis-modal-content has-background-white">
            <div className="block p-5">
              <h3 className="title is-5">{title}</h3>
              <figure className="image">
                <img src={src} alt={alt} />
              </figure>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicationAnalysisFigure;
